import React from 'react';
import PropTypes from 'prop-types';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import GridItem from './GridItem';
import styles from '../css/app.css';

const Grid = ({
  posts,
  scrollPosition,
}) => {
  const children = posts.map(
    ({
      thumbnail,
      imageAlt,
      link,
      id,
      service_update_id,
    }) => {
      if (link) {
        return (
          <GridItem
            scrollPosition={scrollPosition}
            key={id}
            serviceUpdateId={service_update_id}
            imageSrc={thumbnail}
            imageAlt={imageAlt || 'Instagram post'}
            imageUrl={link}
          />
        );
      }
      return null;
    }
  );
  return (
    <div className={styles.grid}>
      {children}
    </div>
  );
};

Grid.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.string.isRequired,
      imageAlt: PropTypes.string,
      link: PropTypes.string,
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default trackWindowScroll(Grid);



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/components/Grid.jsx
 **/